var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.progress)?_c('span',{staticClass:"tag is-primary"},[_vm._v("\n    In progress\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }